module.exports = __webpack_public_path__ + "static/img/1090.7237626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1090.jpg
// module id = 272
// module chunks = 0